import SummaryConfig from './summary/SummaryConfig';
import SettingsConfig from './settings/SettingsConfig';
import FeesChargesConfig from './fees-charges/FeesChargesConfig';
import TuitionPlansConfig from './tuition-plans/TuitionPlansConfig';
import DiscountsConfig from './discounts/DiscountsConfig';
import CategoriesConfig from './categories/CategoriesConfig';
import StripeOnboardingConfig from './stripe-onboarding/StripeOnboardingConfig';
import StudentsBillingConfig from './students/StudentsBillingConfig';
import StudentDetailConfig from './student-detail/StudentDetailConfig';
import ReportsHubConfig from './reports/ReportsHubConfig';
import OutstandingInvoicesReportConfig from './reports/OutstandingInvoicesReportConfig';
import TuitionReportConfig from './reports/TuitionReportConfig';
import PaymentReportConfig from './reports/PaymentReportConfig';
import DepositReportConfig from './reports/DepositReportConfig';
import CustomerStatementReportConfig from './reports/CustomerStatementReportConfig';
import BillingSummaryReportConfig from './reports/BillingSummaryReportConfig';
import ChildContractReportConfig from './reports/ChildContractReportConfig';

const billingConfigs = [
	SummaryConfig,
	SettingsConfig,
	FeesChargesConfig,
	TuitionPlansConfig,
	DiscountsConfig,
	CategoriesConfig,
	StripeOnboardingConfig,
	StudentsBillingConfig,
	StudentDetailConfig,
	// Reports (D3 catchup)
	ReportsHubConfig,
	OutstandingInvoicesReportConfig,
	TuitionReportConfig,
	PaymentReportConfig,
	DepositReportConfig,
	CustomerStatementReportConfig,
	BillingSummaryReportConfig,
	ChildContractReportConfig,
];

export default billingConfigs;
